import { type Form, type FormSubmission } from "@overmap-ai/common"
import { FormSubmissionService as OvermapFormSubmissionService } from "@overmap-ai/core"
import { saveAs } from "file-saver"
import superagent from "superagent"

import type { RootState } from "../../store"
import type { FormSubmissionPdfExportOptions } from "../../typings/reports"
import type { AppSDK } from "../sdk"
import { getFilenameFromResponse, sendAuthenticated } from "../utils"

export class FormSubmissionService extends OvermapFormSubmissionService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL

	async getFormSubmissionPdf(formSubmissionId: FormSubmission["uuid"], options?: FormSubmissionPdfExportOptions) {
		const response = await sendAuthenticated(this.auth, () =>
			superagent
				.get(`${this.host}/form-submission-export/pdf/${formSubmissionId}/`)
				.query(options ?? {})
				.responseType("blob"),
		)

		const filename = getFilenameFromResponse(response, "Form submission.pdf")

		saveAs(response.body, filename)
	}

	async getFormSubmissionsPdf(
		formId: Form["uuid"],
		formSubmissionIds: FormSubmission["uuid"][],
		options?: FormSubmissionPdfExportOptions,
	) {
		const response = await sendAuthenticated(this.auth, () =>
			superagent
				.post(`${this.host}/form-submission-export/pdf/bulk/${formId}/`)
				.send({ uuids: formSubmissionIds, options: options })
				.responseType("blob"),
		)

		const filename = getFilenameFromResponse(response, "Form submissions.pdf")

		saveAs(response.body, filename)
	}

	async getFormSubmissionsPdfReport(
		formId: Form["uuid"],
		formSubmissionIds: FormSubmission["uuid"][],
		options?: FormSubmissionPdfExportOptions,
	) {
		await sendAuthenticated(this.auth, () =>
			superagent
				.post(`${this.host}/form-submission-export/pdf/bulk/${formId}/`)
				.query({ report: true })
				.send({ uuids: formSubmissionIds, options: options }),
		)
	}
}
